// DEV 
// export const apiURL = 'https://trevly.api.dev.binmatter.com/branches';
// PROD
export const apiURL = 'https://trevly.api.prod.binmatter.net/branches';
